import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AppProvider } from './context/AppContext';
import MainLayout from './components/layout/MainLayout';
import Login from './pages/Login';
import ResetPassword from './pages/ResetPassword';
import Dashboard from './pages/Dashboard';
import Cabinets from './pages/Cabinets';
import CabinetDetail from './pages/CabinetDetail';
import Operations from './pages/Operations';
import Users from './pages/Users';
import Vendors from './pages/Vendors';
import Lists from './pages/Lists';
import Settings from './pages/Settings';
import Shares from './pages/Shares';
import Investors from './pages/Investors';
import InvestorDetail from './pages/InvestorDetail';
import SpareParts from './pages/SpareParts';
import PublicShare from './pages/PublicShare';
import './App.css';

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/s/:token" element={<PublicShare />} />

          {/* Protected routes */}
          <Route element={<MainLayout />}>
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/cabinets" element={<Cabinets />} />
            <Route path="/cabinets/:id" element={<CabinetDetail />} />
            <Route path="/operations" element={<Operations />} />
            <Route path="/operations/new" element={<Operations />} />
            <Route path="/users" element={<Users />} />
            <Route path="/vendors" element={<Vendors />} />
            <Route path="/lists" element={<Lists />} />
            <Route path="/shares" element={<Shares />} />
            <Route path="/investors" element={<Investors />} />
            <Route path="/investors/:id" element={<InvestorDetail />} />
            <Route path="/spare-parts" element={<SpareParts />} />
            <Route path="/settings" element={<Settings />} />
          </Route>

          {/* Default redirect */}
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;
